import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  hideSpinner,
  showSpinner,
} from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { VisorService } from '../../services/visor.service';
import { NotificationHelper } from "src/app/core/services/helpers/notification.helper";
import { FormBuilder, Validators } from "@angular/forms";




@Component({
  selector: 'app-visor',
  templateUrl: './visor.component.html',
  styleUrls: ['./visor.component.scss'],
})
export class VisorComponent implements OnInit {
  

  respuesta_habeasData: boolean;
  cotizacion: any;

  
  numero: any;
  otpEnviada: boolean = false;
  codigoEnviado: boolean = false;
  cargar: boolean = false;
  aprobado: boolean = false;
  intentos: number = 0;
  otp: any;
  restantes: number=3;

  docs: any;
  doc_selected: any;
  n_ide: any;
  result: any;
  data: any = {
    primer_nombre: '',
    primer_apellido: '',
    correo: '',
    celular: '',
    ingresos: '',
  };
  mostrar: string;
  constructor(
    private _VisorService: VisorService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private notificationHelper: NotificationHelper
  ) { }

  ngOnInit(): void {
    this.tipo_docs();
  }
  modo_c = async (cedula, tipo_doc) => {
    showSpinner();
    cedula && (this.result = await this._VisorService.modo_c(tipo_doc, cedula));
    if (!this.result.success) {
      this.helpers.notifications.warningMessage(this.result.data.msn_error);
    } else {
      this.result = this.result.data;
      if (this.result.hasOwnProperty('cupo')) {
        let cupoValue = this.result.cupo;
      
        if (typeof cupoValue === 'number') {
          let formattedCupo = cupoValue.toLocaleString('es-CO', {
            style: 'currency',
            currency: 'COP',
          });
      
          this.result.cupo = formattedCupo;
        }
      }
      this.data.primer_nombre = this.result.primer_nombre;
      this.data.primer_apellido = this.result.primer_apellido;
      this.data.celular = this.result.celular;
      this.data.ingresos = this.result.ingresos;
      if (this.result.salida==='NUEVO') {
        this.mostrar = 'evaluar';

      } else {
        this.mostrar = 'detalle';
      }
    }
    hideSpinner();
  };

  tipo_docs = async () => {
    let result: any = await this._VisorService.documents_types();
    this.docs = result['data'];
    this.doc_selected = 'CC';
  };
  modo_e = async () => {
    showSpinner();

    this.data.ingresos=0;

    let body = {
      primer_nombre: this.data.primer_nombre,
      primer_apellido: this.data.primer_apellido,
      actividad_cargo: '',
      ocupacion: '1',
      celular: '' + this.data.celular + '',
      ingresos: '' + this.data.ingresos + '',
      correo: this.data.correo,
      tipo_doc: this.doc_selected,
      sector_trabajo: '',
      agencia_seleccionada: this.result.c_agr,
      canal_venta: 'distancia',
      internal_id: this.result.internal_id,
      agency: this.result.c_agr,
      vendedor: this.result.usuario,
      usuario: this.result.usuario,
      programa: this.result.programa,
      cod_vendedor:""
    };
    let data: any = await this._VisorService.modo_e(body, this.n_ide);
    if (data.success) {
      if (
        data.data.msn_error != ''
      ) {
        hideSpinner();
        this.helpers.notifications.errorMessage(data.data.msn_error);
      } else {
        this.result = data.data;
        if (this.result.hasOwnProperty('cupo')) {
          let cupoValue = this.result.cupo;
        
          if (typeof cupoValue === 'number') {
            let formattedCupo = cupoValue.toLocaleString('es-CO', {
              style: 'currency',
              currency: 'COP',
            });
        
            this.result.cupo = formattedCupo;
          }
        }
        this.mostrar = 'detalle';
        hideSpinner();

      }
    } else {
      hideSpinner();
      this.helpers.notifications.errorMessage(data.message);
    }
  };
  
  async mostrar_habeas(){
    this.result = true;
    this.mostrar = 'habeas';
  }

  async funcion_modal_otp(numero: string) {
    try {
      const resp = await this._VisorService.modal_otp_new_habeas(numero);
      if (resp) {
        this.cargar = true;
        const response: any = await this._VisorService.funcion_enviar_otp(this.n_ide, this.numero, '', 'H');
        this.data.celular=numero;
        if (response.attempts_send_sms_otp) {
          this.otpEnviada = true;
        } else {
          this.intentos = 2;
          this.volverEnviarOtp();
        }
      }
    } catch (err) {
      this.cargar = false;
    } finally {
      this.cargar = false;
    }
  }

  async verificar_otp() {
    try {
      this.cargar = true;
      this.codigoEnviado = true;
      const result: any = await this._VisorService.funcion_validar_otp(this.n_ide, this.otp, 'H');
      if (result.message) {
        this.aprobado = true;
        await this._VisorService.funcion_desmaterializar_new(
          this.n_ide,
          this.numero,
          '',
          this.otp
        );
        setTimeout(() => {
          this.respuesta_habeasData=true;
        }, 5000);
        this.cargar = false;
        this.modo_c(this.n_ide,this.doc_selected)
      } else {
        this.cargar = false;
        this.aprobado = false;
      }
    } catch (err) {
      this.cargar = false;
    }
  }
  
  volverEnviarOtp() {
    if (this.intentos < 2) {
      this.intentos++;
      this.restantes=this.restantes-1;
      this.notificationHelper.warningMessage(`Intentos restantes: ${this.restantes} `)
      this.otpEnviada = false
      this.codigoEnviado = false
      this.cargar = false
      this.aprobado = false
      return;
    }
    this.notificationHelper.warningMessage(
        'Se ha superado la cantidad máxima de intentos'
      )
    this.notificationHelper.warningMessage(
        'Debes dirigirte al punto de financiación para que se firme en físico la autorización.'
      )
  }
  noCode() {
    this.otpEnviada = false;
  }

  funcion_cliente_no_acepta() {
    location.reload();
    /*this.clientesStoragesService.Borrar_Clientes(this.varibales_de_credito.cliente_ubicacion)
    this.varibales_de_credito.cliente_vector.estado.estado = 'cliente'
    this.varibales_de_credito.cliente_vector.informacion = undefined
    this.varibales_de_credito.clientes_tabs.find(cliente => cliente.storage === this.varibales_de_credito.cliente_ubicacion).nombreApellido = undefined*/
  }
}
